export const GET_MEASUREMENT_DETAILS = '/measurement_detail/query';
export const GET_MEASUREMENT_DETAIL = '/measurement_detail/';
export const POST_MEASUREMENT_DETAIL = '/measurement_detail/';
export const PUT_MEASUREMENT_DETAIL = '/measurement_detail/';
export const DELETE_MEASUREMENT_DETAIL = '/measurement_detail/';
